import en from './en-US'
import km from './km-Kh'

export default {
    ...en,
    ...km
}